import HekateFormDefinition from '../HekateForm/HekateFormDefinition';
import HekateDisplayField from './HekateDisplayField';
export default class HekateDisplayForm extends HekateFormDefinition {
    constructor({ id, name, updatedBy, updatedAt, htmlName, folderId, elements, isRecaptcha, isHidden, screenNumber, }) {
        super({
            id,
            name,
            updatedBy,
            updatedAt,
            htmlName,
            elements,
            folderId,
        });
        this.displayFields = elements.map((elm) => new HekateDisplayField(elm));
        this.errorMessages = [];
        this.isRecaptcha = !!isRecaptcha;
        this.isHidden = !!isHidden;
        this.screenNumber = screenNumber !== null && screenNumber !== void 0 ? screenNumber : 0;
    }
}
